// 订单来源业务组件
import * as React from "react";
// import PrimaryCategories from "./primaryCategories";
// import SecondCategories from "./secondCategories";
import * as OSInstance from "./instance";
import FormModel from "../../viewModel/formModel";
import { connect } from "react-redux";

interface ISecondaryLinkageProps {
  primaryData: FormModel;
  secondData: FormModel;
  CreateForm: any;
}

// 订单来源 二级联动组件
class SecondaryLinkage extends React.Component<ISecondaryLinkageProps, any> {
  constructor(props: ISecondaryLinkageProps) {
    super(props);
  }

  getValue = (model, field) => {
    for (const key in this.props.CreateForm[model]) {
      if (key === field) {
        return this.props.CreateForm[model][key];
      } else {
        continue;
      }
    }
    return null;
  };

  render() {
    // 获取Redux 中的值
    let countryValue = this.getValue(
      this.props.primaryData.modelName,
      this.props.primaryData.field
    );
    this.props.primaryData.value = countryValue;

    // 获取保持在Redux中的值
    let cityValue = this.getValue(
      this.props.secondData.modelName,
      this.props.secondData.field
    );
    this.props.secondData.value = cityValue;

    return (
      <React.Fragment>
        {OSInstance.getPrimaryCategories(this.props.primaryData)}
        {/* <PrimaryCategories width={this.props.width || 140} /> */}
        <span style={{ marginLeft: 8 }}>
          {OSInstance.getSecondCategories(this.props.secondData)}
          {/* <SecondCategories /> */}
        </span>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  CreateForm: state.antDemo
});

const mapDispatch = dispatch => {
  return {
    setValue: dispatch.antDemo.setValue
  };
};

export default connect(
  mapState,
  mapDispatch
)(SecondaryLinkage);
